/**
 * @module Theme
 */

import { ThemeModel } from '@models/theme.model';
import { UidModel } from '@models/uid.model';
import { ModificationClass } from '@class/modification.class';
import { UidClass } from '@class/uid.class';
import { LabelsClass } from '@class/labels.class';
import { DescriptionsClass } from '@class/descriptions.class';
import { LinksClass } from '@class/links.class';
import { LogsClass } from '@class/logs.class';
import { TagsClass } from '@class/tag.class';
import { LabelsModel } from '@models/labels.model';
import { DescriptionsModel } from '@models/descriptions.model';
import { LinksModel } from '@models/links.model';
import { LogsModel } from '@models/logs.model';
import { TagsModel } from '@models/tag.model';
import { DeepCopy } from '@functions/copy.functions';

export class ThemeClass extends ModificationClass<ThemeModel> {
  
  private _uid: UidClass;
  private _labels: LabelsClass;
  private _descriptions: DescriptionsClass;
  private _links: LinksClass;
  private _logs: LogsClass;
  private _tags: TagsClass;

  protected _parent: ThemeModel;
  protected _inital: ThemeModel;
  protected _attributes: string[];

  private _isRegistered: boolean;

  constructor(theme: ThemeModel, isRegistered: boolean = true) {

    super();

    this._parent = theme;
    this._isRegistered = isRegistered;

    this._reset(this._parent);

    this._attributes = this.attributes.slice();
    this._attributes.push(...this._uid.attributes);
    this._attributes.push(...this._labels.attributes);
    this._attributes.push(...this._descriptions.attributes);
    this._attributes.push(...this._links.attributes);
    this._attributes.push(...this._logs.attributes);
    this._attributes.push(...this._tags.attributes);

  }

  private _reset(theme: ThemeModel) {
    this._uid = new UidClass(theme as UidModel, this._isRegistered);
    this._labels = new LabelsClass(theme as LabelsModel, this._form, this._requirements, this._state);
    this._descriptions = new DescriptionsClass(theme as DescriptionsModel, this._form, this._requirements, this._state);
    this._links = new LinksClass(theme as LinksModel, this._state);
    this._logs = new LogsClass(theme as LogsModel, this._state);
    this._tags = new TagsClass(theme as TagsModel, this._state);

    this.attributes.forEach((attribute: string) => {
      this._parent[attribute] = theme[attribute];
    });

    this._inital = DeepCopy(theme);

    this._state.flush();
    this._modifications$.next(this._state);
  }

  reset() {
    this._state.flush();
    this._reset(this._inital);
  }

  get attributes(): Readonly<string[]> {
    return [];
  }

  get class(): string {
    return 'theme';
  }

  get uid(): UidClass {
    return this._uid;
  }

  get labels(): LabelsClass {
    return this._labels;
  }

  get descriptions(): DescriptionsClass {
    return this._descriptions;
  }

  get links(): LinksClass {
    return this._links;
  }

  get logs(): LogsClass {
    return this._logs;
  }

  get tags(): TagsClass {
    return this._tags;
  }

}